import * as React from 'react'
import Svg, {
  SvgProps,
  Defs,
  LinearGradient,
  Stop,
  RadialGradient,
  G,
  Path,
  Text,
  TSpan,
  Circle,
  Rect,
} from 'react-native-svg'
import { Image } from 'expo-image'
import ColoredText from '../../CustomText/ColoredText'
import { Platform, TouchableOpacity, View } from 'react-native'
/* SVGR has dropped some elements not supported by react-native-svg: title */
const AR_5 = ({
  props,
  report,
  year,
  onClose,
}: {
  props?: SvgProps
  report: Record<string, any>
  year: string
  onClose: () => Promise<void>
}) => {
  return (
    <>
      <Svg width={393} height={852} {...props}>
        <Defs>
          <LinearGradient id="a" x1="0%" x2="102.004%" y1="100%" y2="0%">
            <Stop offset="0%" stopColor="#FA6A00" />
            <Stop offset="100%" stopColor="#FFCD12" />
          </LinearGradient>
          <LinearGradient id="c" x1="50%" x2="50%" y1="100%" y2="-38.034%">
            <Stop offset="0%" stopColor="#FF5F01" />
            <Stop offset="100%" stopColor="#FFC700" />
          </LinearGradient>
          <LinearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <Stop offset="0%" stopColor="#FD8205" />
            <Stop offset="100%" stopColor="#CE2B02" />
          </LinearGradient>
          <RadialGradient
            id="b"
            cx="50%"
            cy="100%"
            r="222.877%"
            fx="50%"
            fy="100%"
            gradientTransform="matrix(0 -1 .2143 0 .286 1.5)"
          >
            <Stop offset="0%" stopColor="#FFF" />
            <Stop offset="100%" stopColor="#FBEFC5" />
          </RadialGradient>
          <RadialGradient
            id="d"
            cx="13.287%"
            cy="93.924%"
            r="150.8%"
            fx="13.287%"
            fy="93.924%"
            gradientTransform="matrix(.20736 -.84745 .33101 .53088 -.206 .553)"
          >
            <Stop offset="0%" stopColor="#FD4C00" />
            <Stop offset="100%" stopColor="#FF6100" />
          </RadialGradient>
          {Platform.OS !== 'web' && (
            <>
              <Image
                style={{ top: 370, left: 25, width: 130, height: 130, borderRadius: 100, backgroundColor: 'white' }}
                id="a"
                source={report.data.runner[0].cThumbnail.cURLKlein}
                contentFit="cover"
              />
              <ColoredText style={{ top: 230, left: 175, width: 200, color: `#000`, fontSize: 18, maxHeight: 150 }}>
                {report.data.runner[0].cName}
              </ColoredText>
              <ColoredText
                style={{
                  top: 255,
                  left: 175,
                  width: 200,
                  color: `#000`,
                  fontSize: 22,
                  maxHeight: 150,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[0].nAmount} mal verkauft`}
              </ColoredText>
            </>
          )}
        </Defs>
        <G fill="none" fillRule="evenodd">
          <Path fill="#FFF" d="M0 0h393v852H0z" />
          <Path fill="url(#a)" d="M171.054 0h995v995h-995z" transform="translate(-370.361 -93)" />
          <Path
            fill="url(#b)"
            d="M487.497 438.076h621.305c58.756 0 106.388 40.01 106.388 89.366 0 49.355-47.632 89.366-106.388 89.366H487.497c-58.756 0-106.387-40.01-106.387-89.366 0-49.355 47.631-89.366 106.387-89.366Z"
            opacity={0.202}
            transform="translate(-370.361 -93)"
          />
          <Path
            fill="url(#c)"
            d="M299.97 333.049h866.084c0 238.66-6.142 143.215-6.142 282.377s-15.97 10.134 0 240.919L299.97 836.998C134.3 836.998 0 724.185 0 585.023 0 445.861 134.301 333.05 299.97 333.05Z"
            opacity={0.202}
            transform="translate(-370.361 -93)"
          />
          <Path
            fill="url(#d)"
            d="m792.446 101.803 373.608.922v186.562l-373.608-8.752c-58.756 0-106.387-40.01-106.387-89.366 0-49.355 47.631-89.366 106.387-89.366Z"
            opacity={0.269}
            transform="translate(-370.361 -93)"
          />
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M174.5 607.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 175.11 596a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM262.5 172.25h10.687a.51.51 0 0 0 .399-.187.624.624 0 0 0 .164-.422 10.913 10.913 0 0 0-1.594-5.203 11.31 11.31 0 0 0-3.844-3.844A10.913 10.913 0 0 0 263.11 161a.624.624 0 0 0-.422.164.51.51 0 0 0-.187.399v10.687Zm12.422 2.25h-10.688l7.547 7.547c.125.125.266.18.422.164a.684.684 0 0 0 .422-.211 10.983 10.983 0 0 0 2.039-3.234c.484-1.188.758-2.407.82-3.657a.624.624 0 0 0-.164-.421.51.51 0 0 0-.398-.188Zm-7.125 6.797-7.547-7.547v-10.687a.51.51 0 0 0-.188-.399.624.624 0 0 0-.421-.164 11.3 11.3 0 0 0-5.344 1.711 11.195 11.195 0 0 0-3.867 4.055c-.953 1.687-1.43 3.53-1.43 5.53 0 2 .508 3.86 1.523 5.58a11.465 11.465 0 0 0 4.102 4.1c1.719 1.016 3.594 1.524 5.625 1.524a11.175 11.175 0 0 0 7.547-2.906.595.595 0 0 0 .164-.375.506.506 0 0 0-.164-.422ZM330.571 660.571a2.572 2.572 0 0 1 2.572-2.571h1.714a2.572 2.572 0 0 1 2.572 2.571v18.858a2.572 2.572 0 0 1-2.572 2.571h-1.714a2.572 2.572 0 0 1-2.572-2.571V660.57ZM322 670.857a2.572 2.572 0 0 1 2.571-2.571h1.715a2.572 2.572 0 0 1 2.571 2.571v8.572a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571v-8.572Zm21.429-9.428A2.572 2.572 0 0 1 346 664v15.429a2.572 2.572 0 0 1-2.571 2.571h-1.715a2.572 2.572 0 0 1-2.571-2.571V664a2.572 2.572 0 0 1 2.571-2.571h1.715ZM62 714.174c0 .648-.552 1.174-1.232 1.174H40.232c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H50.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393H44.586c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837ZM364 96.174c0 .648-.552 1.174-1.232 1.174h-20.536c-.68 0-1.232-.48-1.232-1.174 0-.648.552-1.174 1.186-1.174h2.89c.346-2.63 2.387-4.751 5.056-5.322.289-.988 1.192-1.678 2.368-1.678h3.193c1.192 0 2.285.768 2.51 1.882.257 1.5-.898 2.77-2.417 2.77H352.5c-.68 0-1.296-.263-1.74-.64-1.642.33-2.894 1.521-3.22 2.988h15.228c.683 0 1.232.567 1.232 1.174Zm-20.536 2.74h18.072l-1.48 12.693c-.093.793-.805 1.393-1.642 1.393h-11.828c-.838 0-1.549-.6-1.641-1.393l-1.48-12.694Zm4.903 6.637 1.694 1.572-.397 2.226c-.078.403.372.703.744.513l2.092-1.051 2.092 1.051c.379.19.822-.11.744-.513l-.397-2.226 1.694-1.572a.486.486 0 0 0-.289-.837l-2.343-.33-1.046-2.024a.522.522 0 0 0-.918 0l-1.046 2.024-2.343.33a.485.485 0 0 0-.28.837Z"
            opacity={0.292}
          />
          <Text
            fill="#000"
            fontFamily={'Comfortaa_500Medium'}
            fontSize={24}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={20.588} y={250}>
              {`Dieses Produkt hast du ${year}`}
            </TSpan>
            <TSpan x={55} y={286}>
              {'am h\xE4ufigsten verkauft:'}
            </TSpan>
          </Text>
          <Path
            fill="#000"
            d="M159.537 785.133c.454 0 .82.14 1.096.418.276.278.414.646.414 1.103v13.597c0 1.55-.36 2.957-1.08 4.22a7.99 7.99 0 0 1-2.932 2.981c-1.233.726-2.61 1.088-4.13 1.088s-2.906-.362-4.16-1.088a7.815 7.815 0 0 1-2.946-2.982c-.71-1.262-1.066-2.669-1.066-4.219 0-1.55.33-2.957.992-4.22.661-1.262 1.57-2.25 2.724-2.966 1.155-.716 2.443-1.074 3.864-1.074a7.25 7.25 0 0 1 5.714 2.714v-8.051c0-.457.143-.825.43-1.103.286-.279.646-.418 1.08-.418Zm-6.632 20.724c.987 0 1.88-.244 2.68-.73a5.116 5.116 0 0 0 1.88-2.014c.454-.854.68-1.808.68-2.862s-.226-2.003-.68-2.848a5.143 5.143 0 0 0-1.88-1.997c-.8-.487-1.693-.731-2.68-.731-.987 0-1.88.244-2.68.73a5.252 5.252 0 0 0-1.894 1.998c-.464.845-.696 1.794-.696 2.848 0 1.054.232 2.008.696 2.862a5.224 5.224 0 0 0 1.895 2.013c.799.487 1.692.73 2.68.73Zm20.074-13.866c1.52 0 2.897.363 4.13 1.089a7.99 7.99 0 0 1 2.932 2.982c.72 1.262 1.08 2.668 1.08 4.219v6.65c0 .436-.143.8-.43 1.088-.285.288-.646.432-1.08.432-.434 0-.794-.144-1.08-.432-.287-.289-.43-.652-.43-1.089v-1.103a7.261 7.261 0 0 1-5.714 2.713c-1.421 0-2.71-.357-3.864-1.073-1.155-.716-2.063-1.705-2.724-2.967s-.992-2.669-.992-4.22c0-1.55.356-2.956 1.066-4.218a7.815 7.815 0 0 1 2.946-2.982c1.254-.726 2.64-1.089 4.16-1.089Zm0 13.866c.987 0 1.88-.244 2.68-.73a5.143 5.143 0 0 0 1.88-1.999c.454-.844.68-1.794.68-2.847 0-1.054-.226-2.008-.68-2.863a5.116 5.116 0 0 0-1.88-2.012c-.8-.487-1.693-.731-2.68-.731-.987 0-1.88.244-2.68.73a5.224 5.224 0 0 0-1.894 2.013c-.464.855-.696 1.81-.696 2.863s.232 2.003.696 2.847a5.252 5.252 0 0 0 1.895 1.998c.799.487 1.692.73 2.68.73Zm18.327-13.866c1.283 0 2.433.21 3.45.627 1.016.417 1.82.994 2.413 1.729.256.318.384.636.384.954 0 .338-.167.646-.503.925-.217.159-.493.238-.829.238-.513 0-.977-.189-1.391-.566-.494-.458-1.017-.78-1.57-.97-.552-.188-1.223-.283-2.013-.283-.908 0-1.653.154-2.235.462-.583.308-.874.74-.874 1.297 0 .398.099.731.296 1 .198.268.573.516 1.125.745.553.228 1.352.452 2.399.67 2.151.438 3.676 1.044 4.574 1.82.898.775 1.347 1.779 1.347 3.011 0 .915-.247 1.745-.74 2.49-.493.745-1.219 1.332-2.176 1.76-.958.427-2.107.64-3.45.64-1.342 0-2.605-.208-3.79-.626-1.184-.417-2.111-.964-2.782-1.64a1.266 1.266 0 0 1-.385-.924c0-.477.197-.865.592-1.163.375-.278.72-.418 1.036-.418.395 0 .77.18 1.125.537.375.418.938.78 1.688 1.089a6.25 6.25 0 0 0 2.398.462c1.125 0 1.999-.19 2.62-.567.622-.378.933-.884.933-1.52 0-.617-.306-1.129-.918-1.536-.612-.408-1.648-.75-3.109-1.029-3.79-.735-5.684-2.306-5.684-4.711 0-.974.286-1.8.858-2.475.573-.676 1.323-1.183 2.25-1.52a8.583 8.583 0 0 1 2.961-.508Zm18.446-.03c1.362 0 2.586.299 3.671.895 1.086.596 1.935 1.466 2.546 2.61.612 1.142.918 2.519.918 4.129v7.335c0 .437-.143.8-.429 1.089-.286.288-.646.432-1.08.432-.435 0-.795-.144-1.081-.432-.287-.289-.43-.652-.43-1.089v-7.335c0-1.61-.429-2.828-1.288-3.653-.858-.825-1.998-1.237-3.42-1.237-.828 0-1.583.169-2.264.507-.681.338-1.214.795-1.6 1.371a3.413 3.413 0 0 0-.576 1.939v8.408c0 .437-.139.8-.415 1.089-.276.288-.641.432-1.095.432-.435 0-.795-.144-1.081-.432-.286-.289-.43-.652-.43-1.089v-20.276c0-.457.144-.825.43-1.103.286-.279.646-.418 1.08-.418.455 0 .82.14 1.096.418.276.278.415.646.415 1.103v7.305a6.577 6.577 0 0 1 2.25-1.476 7.415 7.415 0 0 1 2.783-.521Zm18.294-6.828c.257 0 .469.08.637.239.167.159.251.378.251.656v9.303c.652-1.054 1.545-1.883 2.68-2.49 1.135-.606 2.403-.91 3.804-.91 1.56 0 2.971.364 4.234 1.09a7.861 7.861 0 0 1 2.976 2.996c.72 1.272 1.08 2.683 1.08 4.234 0 1.57-.36 2.992-1.08 4.264a7.861 7.861 0 0 1-2.976 2.997c-1.263.725-2.674 1.088-4.234 1.088-1.52 0-2.906-.353-4.16-1.059a7.844 7.844 0 0 1-2.975-2.937c-.73-1.252-1.105-2.643-1.125-4.174v-14.402c0-.278.079-.497.237-.656.158-.16.375-.239.651-.239Zm7.372 21.797c1.224 0 2.33-.293 3.317-.88a6.403 6.403 0 0 0 2.339-2.4c.572-1.014.858-2.147.858-3.399 0-1.252-.286-2.385-.858-3.4a6.291 6.291 0 0 0-2.34-2.385c-.986-.576-2.092-.864-3.316-.864-1.223 0-2.329.288-3.316.864a6.184 6.184 0 0 0-2.324 2.386c-.562 1.014-.844 2.147-.844 3.399 0 1.252.282 2.385.844 3.4a6.292 6.292 0 0 0 2.324 2.4c.987.586 2.093.88 3.316.88Zm18.694-14.998c1.54 0 2.941.363 4.205 1.088a7.861 7.861 0 0 1 2.975 2.997c.72 1.272 1.081 2.693 1.081 4.264v7.246a.902.902 0 0 1-.237.64c-.158.17-.375.254-.651.254a.86.86 0 0 1-.637-.253.872.872 0 0 1-.251-.641V805.2c-.652 1.053-1.545 1.883-2.68 2.49-1.135.606-2.403.909-3.805.909-1.559 0-2.97-.363-4.233-1.088a7.861 7.861 0 0 1-2.976-2.997c-.72-1.272-1.08-2.684-1.08-4.234 0-1.57.36-2.992 1.08-4.264a7.861 7.861 0 0 1 2.976-2.997c1.263-.725 2.674-1.088 4.233-1.088Zm0 14.998c1.224 0 2.33-.288 3.317-.865a6.184 6.184 0 0 0 2.324-2.385c.562-1.014.844-2.147.844-3.4 0-1.252-.282-2.385-.844-3.398a6.292 6.292 0 0 0-2.324-2.4c-.987-.587-2.093-.88-3.317-.88-1.223 0-2.329.293-3.316.88a6.403 6.403 0 0 0-2.339 2.4c-.572 1.013-.858 2.146-.858 3.399 0 1.252.286 2.385.858 3.399a6.291 6.291 0 0 0 2.34 2.385c.986.577 2.092.865 3.315.865Zm19.571-14.998c1.5 0 2.25.328 2.25.984 0 .1-.01.179-.03.238-.058.219-.152.373-.28.462-.129.09-.302.135-.519.135-.177 0-.41-.02-.695-.06a5.417 5.417 0 0 0-.726-.06c-.987 0-1.865.21-2.635.627a4.6 4.6 0 0 0-1.806 1.729c-.434.736-.651 1.56-.651 2.475v9.065a.902.902 0 0 1-.237.64c-.158.17-.375.254-.652.254a.86.86 0 0 1-.636-.253.872.872 0 0 1-.252-.641v-14.522c0-.278.084-.497.252-.656a.888.888 0 0 1 .636-.238c.277 0 .494.08.652.238.158.16.237.378.237.656v1.849a6.304 6.304 0 0 1 2.19-2.147 5.668 5.668 0 0 1 2.902-.775Z"
          />
          <Path
            fill="#F5A623"
            d="M120.556 785.133h14.222c1.963 0 3.555 1.66 3.555 3.706v16.056c0 2.046-1.592 3.705-3.555 3.705h-14.222c-1.964 0-3.556-1.659-3.556-3.705v-16.056c0-2.047 1.592-3.706 3.556-3.706Z"
          />
          <Path
            fill="#FFF"
            d="M120.516 802.733h14.302c1.352 0 2.449 1.194 2.449 2.667 0 1.473-1.097 2.667-2.45 2.667h-14.301c-1.353 0-2.45-1.194-2.45-2.667 0-1.473 1.097-2.667 2.45-2.667Z"
          />
          <Path
            fill="#F5A623"
            d="M222.067 804.333c.577 0 1.077.21 1.5.63.422.42.633.926.633 1.519 0 .573-.206 1.07-.618 1.489-.413.42-.918.629-1.515.629-.577 0-1.077-.21-1.5-.63-.422-.419-.634-.915-.634-1.488 0-.593.212-1.1.634-1.52.423-.419.923-.629 1.5-.629Z"
          />
          <G transform="translate(351 50)" onPress={onClose}>
            <Circle cx={14.5} cy={14.5} r={14.5} fill="#1E2239" />
            <Path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.711 21.228a1.25 1.25 0 1 1-1.92 1.6l-5.29-6.38-5.29 6.347a1.247 1.247 0 0 1-1.76.16 1.25 1.25 0 0 1-.16-1.76l5.582-6.7L7.29 7.83a1.25 1.25 0 1 1 1.92-1.6l5.29 6.346 5.29-6.348a1.249 1.249 0 1 1 1.92 1.6l-5.583 6.7 5.584 6.7Z"
            />
          </G>
          <G fill="#D8D8D8" transform="translate(10 61.596)">
            <Rect width={36.056} height={4.807} rx={2.404} />
            <Rect width={36.056} height={4.807} x={42.065} rx={2.404} />
            <Rect width={36.056} height={4.807} x={84.13} rx={2.404} />
            <Rect width={36.056} height={4.807} x={126.195} rx={2.404} />
            <Rect width={36.056} height={4.807} x={167.659} rx={2.404} />
            <Rect width={36.056} height={4.807} x={209.711} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={250.827} opacity={0.376} rx={2.404} />
            <Rect width={36.056} height={4.807} x={291.944} opacity={0.376} rx={2.404} />
          </G>
          <Path
            fill="#FFF"
            fillRule="nonzero"
            d="M115.25 182h-3.75v4.714l-1.5-1.046-1.5 1.046V182h-3.75c-.412 0-.75.354-.75.786v9.428c0 .432.338.786.75.786h10.5c.412 0 .75-.354.75-.786v-9.428c0-.432-.338-.786-.75-.786Zm-17.5-2h10.5c.412 0 .75-.354.75-.786v-9.428c0-.432-.338-.786-.75-.786h-3.75v4.714l-1.5-1.046-1.5 1.046V169h-3.75c-.412 0-.75.354-.75.786v9.428c0 .432.338.786.75.786Zm2.5 2H96.5v4.714l-1.5-1.046-1.5 1.046V182h-3.75c-.412 0-.75.354-.75.786v9.428c0 .432.338.786.75.786h10.5c.412 0 .75-.354.75-.786v-9.428c0-.432-.338-.786-.75-.786Z"
            opacity={0.297}
          />
          <Path fill="url(#e)" d="M-4 751h406v112H-4z" />
          <Text
            fill="#FFF"
            fontFamily={'Comfortaa_700Bold'}
            fontSize={40}
            fillRule={Platform.OS !== 'android' ? 'nonzero' : 'evenodd'}
          >
            <TSpan x={10} y={129}>
              {'Produkte'}
            </TSpan>
          </Text>
        </G>
      </Svg>
      {Platform.OS === 'web' && (
        <>
          <TouchableOpacity
            onPress={onClose}
            style={{ position: 'absolute', top: 50, marginLeft: 330, width: 50, height: 50 }}
          />
          <View
            style={{
              position: 'absolute',
              top: 370,
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              alignContent: 'flex-start',
              width: 350,
            }}
          >
            <Image
              style={{ width: 130, height: 130, borderRadius: 100 }}
              id="a"
              source={report.data.runner[0].cThumbnail.cURLKlein}
              contentFit="cover"
            />
            <View style={{ width: 200, marginLeft: 20 }}>
              <ColoredText style={{ color: `#000`, fontSize: 18, maxHeight: 150 }}>
                {report.data.runner[0].cName}
              </ColoredText>
              <ColoredText
                style={{
                  marginTop: 10,
                  color: `#000`,
                  fontSize: 22,
                  maxHeight: 150,
                  fontFamily: `Comfortaa-Bold`,
                }}
              >
                {`${report.data.runner[0].nAmount} mal verkauft`}
              </ColoredText>
            </View>
          </View>
        </>
      )}
    </>
  )
}
export default AR_5
